import {ModuleHeading, dimensions} from '@bettermarks/bm-ui-components';
import styled, {css} from 'styled-components';
import {CheckBox} from '../../components/Checkbox';
import {Group, TextModule} from '../../components/LayoutComponents';

export const HeadingGroup = styled.div`
  flex: 1;
`;

export const StyledModuleHeading = styled(ModuleHeading)<{gap?: boolean}>`
  display: flex;
  align-items: center;
  font-weight: 500;
  padding-bottom: 0;
  ${p =>
    p.gap &&
    css`
      padding-left: 36px;
    `}

  ${CheckBox} {
    margin-right: 16px;
  }
  border: none;
  ${HeadingGroup} {
    border-bottom: 1px solid #ccc;
    padding: ${dimensions.spaceM} ${dimensions.spaceM} ${dimensions.spaceM} 0;
  }
`;

export const BookIntro = (
  <Group>
    <StyledModuleHeading as='h4' border gap>
      <HeadingGroup>Einleitung</HeadingGroup>
    </StyledModuleHeading>

    <TextModule>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
        tempor incididunt ut labore et dolore magna aliqua. Libero enim sed
        faucibus turpis in eu mi bibendum neque. Aliquet sagittis id consectetur
        purus ut faucibus pulvinar elementum integer. Ultricies tristique nulla
        aliquet enim. Eu mi bibendum neque egestas congue quisque egestas.
        <br />
        Et leo duis ut diam quam nulla. Gravida neque convallis a cras. Sit amet
        consectetur adipiscing elit ut aliquam purus sit. Sit amet mattis
        vulputate enim nulla aliquet porttitor lacus. Adipiscing commodo elit at
        imperdiet dui. Amet nulla facilisi morbi tempus iaculis urna id
        volutpat.
        <br />
        Erat nam at lectus urna. Dolor sit amet consectetur adipiscing. Egestas
        purus viverra accumsan in nisl nisi scelerisque eu. Aenean sed
        adipiscing diam donec adipiscing tristique risus nec feugiat. Cursus
        euismod quis viverra nibh cras pulvinar mattis nunc.
      </p>

      <img src='/book-view/FuV3Koe3Kug10.IMG1_300x300.jpg' alt='Globe' />
    </TextModule>
  </Group>
);
